import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getCategoryObjects,
	getCategoryObjectsEndpoint,
	type QueryError,
	type GetCategoryObjectsResult,
	type GetCategoryObjectsRequestOptions,
} from '../getCategoryObjects';
export * from '../getCategoryObjects';

export type GetCategoryObjectsQueryParams = GetCategoryObjectsRequestOptions;
export type GetCategoryObjectsQueryKey = [
	string,
	GetCategoryObjectsQueryParams,
];

export type GetCategoryObjectsQueryOptions = Omit<
	UseQueryOptions<
		GetCategoryObjectsResult,
		QueryError,
		GetCategoryObjectsResult,
		GetCategoryObjectsQueryKey
	>,
	'queryKey' | 'queryFn'
> & {
	queryFn?: typeof getCategoryObjects;
};

/**
 * react-query wrapper for `getCategoryObjects`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetCategoryObjects = (
	queryKeyParams: GetCategoryObjectsQueryParams,
	{
		queryFn = getCategoryObjects,
		...options
	}: GetCategoryObjectsQueryOptions = {},
) =>
	useQuery<
		GetCategoryObjectsResult,
		QueryError,
		GetCategoryObjectsResult,
		GetCategoryObjectsQueryKey
	>({
		queryKey: [getCategoryObjectsEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) => queryFn({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryGetCategoryObjects;
